/**
 * useOracleImage.ts - provides a compile-time record of image imports
 * that allows Webpack to statically analyze the code and bundle the images.
 * This allows static image references on SSR and client-side rendering.
 *
 * See AccountCancelDissatisfied.jsx for inspiration where this came from.
 */
import { useState, useEffect } from 'react'

const loaders = {
  'tarot_king_wands.png': () => import('./img/tarot_king_wands.png'),
  'tarot_strength.png': () => import('./img/tarot_strength.png'),
  'tarot_queen_cups.png': () => import('./img/tarot_queen_cups.png'),
  'tarot-step-1.svg': () => import('../OraclePage/img/tarot-step-1.svg'),
  'tarot-step-2.svg': () => import('../OraclePage/img/tarot-step-2.svg'),
  'tarot-step-3.svg': () => import('../OraclePage/img/tarot-step-3.svg'),
}

export type OracleImageFilename = keyof typeof loaders

export const useOracleImage = (filename: OracleImageFilename): string | null => {
  const [src, setSrc] = useState<string | null>(null)
  useEffect(() => {
    loaders[filename]().then((mod) => setSrc(mod.default))
  }, [filename])
  return src
}
